import { UserMenuItem } from './user-menu-item';
import { isNullOrUndefined } from 'util';

export class UserMenu {
  menu_item_dash = new UserMenuItem();
  menu_item_dash_1 = new UserMenuItem();
  menu_item_dash_2 = new UserMenuItem();
  menu_item_dash_reporting = new UserMenuItem();

  menu_item_wifi_usage = new UserMenuItem();
  menu_item_wifi_usage_session = new UserMenuItem();
  menu_item_wifi_usage_login_method = new UserMenuItem();
  menu_item_wifi_usage_data_stats = new UserMenuItem();

  menu_item_userinfo = new UserMenuItem();

  menu_item_sessions = new UserMenuItem();
  menu_item_sessions_active_sessions = new UserMenuItem();
  menu_item_sessions_sessions_stats = new UserMenuItem();
  // menu_item_sessions_radius_log = new UserMenuItem();

  menu_item_organization = new UserMenuItem();
  menu_item_organization_locations = new UserMenuItem();
  menu_item_organization_location_groups = new UserMenuItem();
  menu_item_organization_regions = new UserMenuItem();
  menu_item_organization_analytics_users = new UserMenuItem();
  menu_item_organization_security_groups = new UserMenuItem();
  menu_item_organization_wifi_users = new UserMenuItem();
  menu_item_organization_login_history = new UserMenuItem();
  menu_item_organization_change_log = new UserMenuItem();
  // menu_item_organization_replication = new UserMenuItem();
  // menu_item_organization_log_journal = new UserMenuItem();

  menu_item_organization_accounts = new UserMenuItem();
  menu_item_organization_accounts_email = new UserMenuItem();
  menu_item_organization_accounts_sms = new UserMenuItem();
  menu_item_organization_accounts_facebook = new UserMenuItem();
  menu_item_organization_accounts_twitter = new UserMenuItem();
  menu_item_organization_accounts_google = new UserMenuItem();
  menu_item_organization_accounts_paypal = new UserMenuItem();
  menu_item_organization_accounts_paypal_options = new UserMenuItem();
  menu_item_organization_accounts_vouchers = new UserMenuItem();
  menu_item_organization_accounts_mailchimp = new UserMenuItem();
  menu_item_organization_accounts_wired_messenger = new UserMenuItem();

  menu_item_organization_cp = new UserMenuItem();
  menu_item_organization_cp_add_update = new UserMenuItem();
  menu_item_organization_cp_lang_locales = new UserMenuItem();
  menu_item_organization_cp_cp_builder = new UserMenuItem(); //
  menu_item_organization_cp_redirect_strategies = new UserMenuItem();
  menu_item_organization_cp_messaging_strategies = new UserMenuItem();
  menu_item_organization_cp_dynamic_images = new UserMenuItem();
  menu_item_organization_cp_image_uploader = new UserMenuItem();
  menu_item_organization_cp_background_uploader = new UserMenuItem();
  menu_item_organization_cp_fonts_uploader = new UserMenuItem();
  menu_item_organization_cp_terms_builder = new UserMenuItem();

  menu_item_organization_vocabularies = new UserMenuItem();
  menu_item_organization_vocabularies_counties = new UserMenuItem();
  menu_item_organization_vocabularies_cp_codes = new UserMenuItem();

  menu_item_admin = new UserMenuItem(); //
  menu_item_admin_clients = new UserMenuItem(); //
  menu_item_admin_forget_user = new UserMenuItem(); //

  constructor(menu) {
    for (const prop in menu) {
      if (menu.hasOwnProperty(prop)) {
        this[prop] = menu[prop];
      }
    }
    if (isNullOrUndefined(this.menu_item_dash)) {
      this.menu_item_dash = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_dash_1)) {
      this.menu_item_dash_1 = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_dash_2)) {
      this.menu_item_dash_2 = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_dash_reporting)) {
      this.menu_item_dash_reporting = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_wifi_usage)) {
      this.menu_item_wifi_usage = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_wifi_usage_session)) {
      this.menu_item_wifi_usage_session = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_wifi_usage_login_method)) {
      this.menu_item_wifi_usage_login_method = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_wifi_usage_data_stats)) {
      this.menu_item_wifi_usage_data_stats = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_userinfo)) {
      this.menu_item_userinfo = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_sessions)) {
      this.menu_item_sessions = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_sessions_active_sessions)) {
      this.menu_item_sessions_active_sessions = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_sessions_sessions_stats)) {
      this.menu_item_sessions_sessions_stats = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_organization)) {
      this.menu_item_organization = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_locations)) {
      this.menu_item_organization_locations = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_location_groups)) {
      this.menu_item_organization_location_groups = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_regions)) {
      this.menu_item_organization_regions = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_analytics_users)) {
      this.menu_item_organization_analytics_users = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_security_groups)) {
      this.menu_item_organization_security_groups = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_wifi_users)) {
      this.menu_item_organization_wifi_users = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_login_history)) {
      this.menu_item_organization_login_history = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_change_log)) {
      this.menu_item_organization_change_log = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_organization_accounts)) {
      this.menu_item_organization_accounts = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_email)) {
      this.menu_item_organization_accounts_email = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_sms)) {
      this.menu_item_organization_accounts_sms = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_facebook)) {
      this.menu_item_organization_accounts_facebook = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_twitter)) {
      this.menu_item_organization_accounts_twitter = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_google)) {
      this.menu_item_organization_accounts_google = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_paypal)) {
      this.menu_item_organization_accounts_paypal = new UserMenuItem();
    }
    if (
      isNullOrUndefined(this.menu_item_organization_accounts_paypal_options)
    ) {
      this.menu_item_organization_accounts_paypal_options = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_vouchers)) {
      this.menu_item_organization_accounts_vouchers = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_accounts_mailchimp)) {
      this.menu_item_organization_accounts_mailchimp = new UserMenuItem();
    }
    if (
      isNullOrUndefined(this.menu_item_organization_accounts_wired_messenger)
    ) {
      this.menu_item_organization_accounts_wired_messenger = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_organization_cp)) {
      this.menu_item_organization_cp = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_add_update)) {
      this.menu_item_organization_cp_add_update = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_lang_locales)) {
      this.menu_item_organization_cp_lang_locales = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_cp_builder)) {
      this.menu_item_organization_cp_cp_builder = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_redirect_strategies)) {
      this.menu_item_organization_cp_redirect_strategies = new UserMenuItem();
    }
    if (
      isNullOrUndefined(this.menu_item_organization_cp_messaging_strategies)
    ) {
      this.menu_item_organization_cp_messaging_strategies = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_dynamic_images)) {
      this.menu_item_organization_cp_dynamic_images = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_image_uploader)) {
      this.menu_item_organization_cp_image_uploader = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_background_uploader)) {
      this.menu_item_organization_cp_background_uploader = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_fonts_uploader)) {
      this.menu_item_organization_cp_fonts_uploader = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_cp_terms_builder)) {
      this.menu_item_organization_cp_terms_builder = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_vocabularies)) {
      this.menu_item_organization_vocabularies = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_vocabularies_counties)) {
      this.menu_item_organization_vocabularies_counties = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_organization_vocabularies_cp_codes)) {
      this.menu_item_organization_vocabularies_cp_codes = new UserMenuItem();
    }

    if (isNullOrUndefined(this.menu_item_admin)) {
      this.menu_item_admin = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_admin_clients)) {
      this.menu_item_admin_clients = new UserMenuItem();
    }
    if (isNullOrUndefined(this.menu_item_admin_forget_user)) {
      this.menu_item_admin_forget_user = new UserMenuItem();
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/main/user-menu.ts